import React from "react";

type UseClickOptions = {
    onHaptic?: () => void;
};

const useClick = (callback: () => void, ref: React.RefObject<HTMLDivElement | HTMLButtonElement>, options?: UseClickOptions) => {
    React.useEffect(() => {
        const node = ref.current;

        if(!node) {
            return;
        }

        const supportsHover = typeof window.matchMedia === "function"
            && window.matchMedia("(hover: hover) and (pointer: fine)").matches;

        if(supportsHover) {
            const onClick = () => {
                options?.onHaptic?.();
                callback();
            };

            node.addEventListener("click", onClick);

            return () => {
                node.removeEventListener("click", onClick);
            };
        }

        if(options?.onHaptic) {
            const onTouchStart = () => {
                setTimeout(callback, 100);
            };

            const onClick = () => {
                options.onHaptic?.();
            };

            node.addEventListener("touchstart", onTouchStart);
            node.addEventListener("click", onClick);

            return () => {
                node.removeEventListener("touchstart", onTouchStart);
                node.removeEventListener("click", onClick);
            };
        }

        node.addEventListener("touchstart", callback);

        return () => {
            node.removeEventListener("touchstart", callback);
        };
    }, [callback, ref, options?.onHaptic]);
};

export default useClick;
